import React from "react";
import { Form, Input, Button, message, Card, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../Login/Login.css"; 
import loginImg from "../../assets/login.jpg.png"; 

const { Title } = Typography;
const BASEURL = process.env.REACT_APP_BASEURL;

const ChangePasswordForm = () => {
  const navigate = useNavigate();

  const url = new URL(window.location.href);
const token = url.pathname.split('/').pop();

  const onFinish = async (values) => {
    ////console.log("Received values:", values);

    if (values.newPassword !== values.confirmNewPassword) {
      message.error("New Password and Confirm New Password do not match!");
      return;
    }

    try {
       await axios.post(
       
         `${BASEURL}/auth/reset-password-confirm`,
        {
            token: token,
          newPassword: values.newPassword,
        }
      );

      message.success("Password changed successfully!");
      ////console.log("Response:", response.data);

      
      navigate("/dashboard");
    } catch (error) {
      // Handle error response
      if (error.response) {
        message.error(
          error.response.data.message || "Failed to change password. Please try again."
        );
      } else {
        message.error("Network error. Please try again later.");
      }
      ////console.error("Change Password error:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="login">
        <div className="login-grid">
          {/* Left Column: Image */}
          <div className="login-image-container">
            <img
              src={loginImg}
              alt="Change Password Illustration"
              className="login-image"
            />
          </div>

          {/* Right Column: Form */}
          <div className="login-form-container">
            <div className="form-wrapper">
              <Title level={2} className="login-title">
                Change Your Password
              </Title>
              <Card title="Change Password" style={{ width: 400, borderRadius: "8px" }}>
                <Form name="changePassword" onFinish={onFinish} layout="vertical">
                  <Form.Item
                    label="New Password"
                    name="newPassword"
                    rules={[
                      { required: true, message: "Please input your new password!" },
                      { min: 6, message: "Password must be at least 6 characters long." },
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Enter your new password"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Confirm New Password"
                    name="confirmNewPassword"
                    rules={[
                      { required: true, message: "Please confirm your new password!" },
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Confirm your new password"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      Change Password
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
